import { render, staticRenderFns } from "./WalletHistory.vue?vue&type=template&id=848c0bbc&scoped=true"
import script from "./WalletHistory.vue?vue&type=script&lang=js"
export * from "./WalletHistory.vue?vue&type=script&lang=js"
import style0 from "./WalletHistory.vue?vue&type=style&index=0&id=848c0bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848c0bbc",
  null
  
)

/* custom blocks */
import block0 from "./WalletHistory.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports